import { getFrequentlyAsked, getSuggestions, getUnansweredQuestions, getRecentDocuments } from "../api/overview.api";

function toDateString(ts) {
	try {
		const d = new Date(ts);
		const opts = { month: "short", day: "numeric", year: "numeric" };
		// Example: Jul 1, 2025
		const s = d.toLocaleDateString(undefined, opts);
		return s.replace(",", ",");
	} catch {
		return ts || "";
	}
}

// Normalize list rows across different endpoints to a common shape used by the UI
// { title, platform, date, count, user }
function mapRow(x) {
	const title = x.title || x.name || x.query || x.document_title || x.question || x.text || "—";
	const platform = x.platform || x.source || x.location || x.provider || x.channel || "Notion";
	const dateRaw = x.date || x.searched_at || x.timestamp || x.last_searched || x.created_at;
	const date = toDateString(dateRaw) || "—";
	const count = x.count ?? x.search_count ?? x.frequency ?? x.times ?? x.total ?? 0;
	const user = x.user || x.email || x.user_email || x.owner || "—";
	return { title, platform, date, count, user };
}

export async function fetchFrequentlyAsked(start, end, limit = 10) {
	const raw = await getFrequentlyAsked(start, end, limit);
	const list = raw?.items || raw?.questions || raw?.data || raw || [];
	return Array.isArray(list) ? list.map(mapRow) : [];
}

export async function fetchSuggestions(limit = 10) {
	const raw = await getSuggestions(limit);
	const list = raw?.items || raw?.suggestions || raw?.data || raw || [];
	return Array.isArray(list) ? list.map(mapRow) : [];
}

export async function fetchUnansweredQuestions(start, end, limit = 10) {
	const raw = await getUnansweredQuestions(start, end, limit);
	const list = raw?.items || raw?.questions || raw?.data || raw || [];
	return Array.isArray(list) ? list.map(mapRow) : [];
}

export async function fetchRecentDocuments(start, end, limit = 5) {
	const raw = await getRecentDocuments(start, end, limit);
	const list = raw?.recentDocuments || raw?.documents || raw?.items || raw?.data || raw || [];
	return Array.isArray(list)
		? list.map((x) =>
				mapRow({
					...x,
					// Prefer explicit document fields if available
					title: x.title || x.document || x.name,
					platform: x.platform || x.source || x.provider || "Notion",
					date: x.date || x.searched_at || x.timestamp,
					count: x.count ?? x.search_count ?? x.frequency,
					user: x.user || x.email || x.user_email
				})
		  )
		: [];
}


